module.exports = __webpack_public_path__ + "img/product4.df010c1a.png";